import { HAS_PARENT_APP, PARENT_APP_IFRAME_ID } from './consts';
import { publishMessageToParentApp } from './utils';

export const GEP_PARENT_LOCATION_OBJECT = 'GEP_PARENT_LOCATION_OBJECT';

const getParentLocationObject = () => {
  return `
    const iframe = parentDocument.getElementById('${PARENT_APP_IFRAME_ID}');
    iframe.contentWindow.postMessage({name: '${GEP_PARENT_LOCATION_OBJECT}', payload: JSON.parse(JSON.stringify(parentWindow.location))}, '*')
  `;
};

export const getParentAppLocationObject = async (): Promise<Location> => {
  if (!HAS_PARENT_APP) return window.location;

  return new Promise((res) => {
    window.addEventListener('message', ({ data: { name }, data }) => {
      if (name === GEP_PARENT_LOCATION_OBJECT) {
        res(data.payload);
      }
    });

    publishMessageToParentApp(getParentLocationObject());
  });
};
